export default "<div class=\"content-wrapper\">\n  <ng-content></ng-content>\n</div>\n"